export default __webpack_public_path__ + "static/media/grafema_illustrations-ua-campaign_09.e36e95e9.jpg";